/* -------------------------------------------------------------------------- */
/* VALIDATION INIT                                                            */
/* -------------------------------------------------------------------------- */
/* eslint-disable camelcase */

import Vue from 'vue';
import { extend } from 'vee-validate';
import {
    alpha, alpha_dash, alpha_num, between, confirmed,
    digits, email, excluded, length,
    max, max_value, min, min_value, numeric, regex, required, required_if,
    size,
} from 'vee-validate/dist/rules';

// Extend Validation Rules
extend('alpha', alpha);
extend('alpha_dash', alpha_dash);
extend('alpha_num', alpha_num);
extend('between', between);
extend('confirmed', confirmed);
extend('digits', digits);
extend('email', email);
extend('excluded', excluded);
extend('length', length);
extend('numeric', numeric);
extend('regex', regex);
extend('required', required);
extend('required_if', required_if);
extend('size', size);

// TODO: Uncomment these lines may produce errors :)
// extend('max', max);
// extend('max_value', max_value);
// extend('min', min);
// extend('min_value', min_value);
